export default function UniNews() {
  const newsItems = [
    {
      id: 1,
      category: '무료급식',
      title: '따뜻한 한 끼, 사랑의 무료급식 봉사',
      description: '어려운 이웃들에게 따뜻한 식사를 제공하는 무료급식 봉사활동을 진행했습니다. 매주 정기적으로 영양가 있는 식사를 준비하여 지역 주민들과 함께 나누고 있습니다.',
      date: '2025.01.12',
      image: 'https://public.readdy.ai/ai/img_res/0f65862c7f2ceb82f182ae6c91075b37.jpg'
    },
    {
      id: 2,
      category: '교육지원',
      title: '지역아동센터 학습교구 지원 사업',
      description: '아이들의 꿈을 응원하기 위해 지역아동센터에 도서와 학습교구를 지원하는 프로그램을 진행했습니다.',
      date: '2025.01.08',
      image: 'https://readdy.ai/api/search-image?query=Bright%20animated%20illustration%20of%20happy%20diverse%20children%20in%20colorful%20library%20receiving%20books%20and%20learning%20materials%2C%20cheerful%20cartoon%20style%2C%20vibrant%20pastel%20colors%2C%20kids%20smiling%20and%20reading%20together%2C%20food%20bank%20shelves%20visible%20in%20background%2C%20volunteers%20distributing%20educational%20supplies%2C%20joyful%20whimsical%20art%20style%2C%20warm%20friendly%20atmosphere%2C%20digital%20illustration&width=800&height=600&seq=news-anime-002&orientation=landscape'
    },
    {
      id: 3,
      category: '의료지원',
      title: '저소득층 가정 의료비 지원 캠페인',
      description: '경제적 어려움으로 치료를 받지 못하는 가정에 의료비를 지원하여 건강한 삶을 되찾을 수 있도록 도왔습니다.',
      date: '2025.01.03',
      image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20animated%20illustration%20of%20healthcare%20workers%20helping%20family%20with%20children%20in%20friendly%20clinic%2C%20cartoon%20style%20art%2C%20vibrant%20pastel%20colors%2C%20compassionate%20care%20scene%2C%20whimsical%20digital%20illustration%2C%20hopeful%20atmosphere%2C%20medical%20support%20with%20warmth%2C%20soft%20friendly%20lighting%2C%20community%20health%20concept&width=800&height=600&seq=news-anime-003&orientation=landscape'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            활동소식
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            <strong>UNI 소개</strong>
          </h2>
          <p className="text-gray-600 text-lg">
            유앤아이월드의 따뜻한 나눔 활동을 소개합니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {newsItems.map((item) => (
            <article
              key={item.id}
              className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:transform hover:-translate-y-2 cursor-pointer"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top transition-transform duration-300 hover:scale-110"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-blue-600 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-6">
                <p className="text-gray-500 text-sm mb-3">{item.date}</p>
                <h3 className="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-gray-600 text-base leading-relaxed line-clamp-3">
                  {item.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}